import React from 'react';
import { Icons } from '../Icons';
import { DateTime } from 'luxon';
export const pauseIcon = React.createElement(Icons, { iconName: "ic-ui-pause" });
export const playIcon = React.createElement(Icons, { iconName: "ic-ui-play" });
export const stopIcon = React.createElement(Icons, { iconName: "ic-ui-stop" });
export const convertToTime = (timestamp, timeZone) => {
    return DateTime.fromSeconds(timestamp)
        .setZone(timeZone)
        .toFormat('HH:mm:ss');
};
//# sourceMappingURL=helpers.js.map